import Vue from "vue"
import { Component } from "vue-property-decorator"
import { mapState } from "vuex";
import { INewContractState } from "../../new-contract-vuex-store";
import { CommonFormatUtils } from "../../../../../Scripts/inpulse/FormatUtils";
import { CustomerTypeEnum } from "../../../../../Scripts/inpulse/CommonEnums";
import { IPriceListViewModel, IProductViewModel, IContractViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import PriceListDisplay from "./components/price-list-display.vue";
import PriceList from "./components/price-list.vue";

@Component({
    components: {
        PriceListDisplay
    },
    computed: mapState({
        product: (state: INewContractState) => state.selectedProduct,
        priceList: (state: INewContractState) => state.selectedPriceList,
        productComponent: (state: INewContractState) => {
            // For some reason price list/product component view models' class structure differs from the data model.
            if (state.selectedPriceList != null && state.selectedPriceList.ProductComponents != null)
                return state.selectedPriceList.ProductComponents[0];
            return null;
        }
    })
})

export default class ProductSelectionDisplay extends Vue {
    get showPricesWithVat(): boolean { return this.$store.state.contract.CustomerType != CustomerTypeEnum.COMPANY; }
    get selectedServiceProducts(): string[] { return this.$store.state.selectedServiceProducts; }
    get product(): IProductViewModel { return this.$store.state.selectedProduct; }
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get selectedConinueWithSameProductId(): number { return this.$store.state.selectedConinueWithSameProductId; }

    get products(): IProductViewModel[] { return this.$store.state.products; }
    get offerRequest(): boolean { return this.$store.state.offerRequest; }
    get selectedPriceList(): IPriceListViewModel { return this.$store.state.selectedPriceList; }
    get selectedProduct(): IProductViewModel { return this.$store.state.selectedProduct; }
    constructor() {
        super();
    }

    formatDuration(contract: IContractViewModel, priceList: IPriceListViewModel) {
        return CommonFormatUtils.formatDuration(contract, priceList, this.$i18n.locale);
    }

    shortProductNames = ["oiva", "optimi", "vihreä", "priima"];
    getProductImageIdentifier(productName: string) {
        let prefix = "pks-product-";
        let retVal = "";
        if (productName) {
            $.each(this.shortProductNames, (i, item) => {
                if (productName.toLowerCase().includes(item)) {
                    retVal = prefix + item;
                }
            })
        }
        return retVal;
    }
}